// extracted by mini-css-extract-plugin
export default {"root":"IconLightning_root__ZspiH"};